<template>
  <div>
    <v-cal-tbl-map
      :reload="reload"
      :eventClick="eventClick"
      :eventTemplate="eventTemplate"
      :getItemColor="getItemColor"
      :coloredFields="['status']"
      :tableKey="tableKey"
      :onDataReceived="onDataReceived"
      :activeTab="activeTab"
      :noDelete="false"
      ref="calTblMap"
      :linkClick="linkClick"
      :link="link"
      :mapTitle="mapTitle"
      :mapReady="mapReady"
      :mapData="mapData"
      :mapLegend="mapLegend"
      :editable="editable"
      :allEditable="false"
      :onMarkerClick="onMarkerClick"
      :showGroupBy="true"
      :dateField="dateField"
      :getDataObject="getDataObject"
      :defaultEventColor="defaultEventColor"
      :updateTable="updateTable"
      :isDraggable="tableDraggable"
      :objKey="objKey"
      :mapLoading="mapLoading"
      :filterTabs="filterTabs"
      :singleSelect="singleSelect"
      :hasSearch="true"
      :tableName="tableName"
      :alwaysUpdate="true"
      :editRow="true"
      :tblVBind="vBind"
      :editedItemTitle="editedItemTitle"
      addButtonCaption="Add New Trip"
      :showFullTable="true"
      :defaultTab="0"
      :resourceVBind="resourceVBind"
      :dataTemplate="dataTemplate"
      :customDayClick="dayClick"
      :resourceInsteadOfTable="true"
      calTabTitle="Trip Calendar"
      tableTabTitle="All Trips"
      :noVueChange="true"
      :key="calKey"
      :activeTabChanged="activeTabChanged"
    >
    </v-cal-tbl-map>
  </div>
</template>

<script>
import { functionsIn } from "lodash";
import * as fun from "../plugins/common";
import axios from "axios";

export default {
  name: "TripDispatch",
  components: {
    // VCombo: () => import("../components/ComboBox.vue"),
    VCalTblMap: () => import("../components/CalTblMap.vue")
  },
  props: {},
  data() {
    return {
      d: null,
      objKey: 0,
      mapTitle: "Trip Map",
      curAgent: "",
      updatedItems: [],
      defaultEventColor: "#137C15FF",
      data_object: null,
      singleSelect: false,
      // activeTab: 0,
      dateField: "date",
      link: {
        field: "shipment_id",
        name: "shipment"
      },
      calKey: 0,
      mapData: [],
      dataTable: [],
      fullData: [],
      showFullData: false,
      width: 4,
      tableDraggable: true,
      filterTabs: [],
      editable: [
        // "trip_name",
        // "etd",
        // "status",
        // "trip_type",
        // "orig_warehouse",
        // "dest_warehouse",
        // "haul_type",
        // "agent",
      ],
      selectedTrip: null,
      selectedTripJobs: [],
      warehouse: [],
      tripJobs: [],
      tripCustomers: [],
      reordered: null,
      tableName: "Trip",
      vBind: null,
      editedItemTitle: ["trip_name"],
      zones: [],
      trips: [],
      resourceVBind: {
        dataTitle: "shipment_id",
        data: [],
        time: [
          // { value: "all day", start: 0, end: 24 },
          // { value: "morning", start: 0, end: 12 },
          // { value: "afternoon", start: 12, end: 18 },
          // { value: "evening", start: 18, end: 24 },
        ],
        timeName: "etd",
        resourceName: "Available Trips",
        dataName: "Unassigned Jobs",
        scheduledDataName: "Trip Assigned",
        trip_status: [],
        // addBtnTitle: "Add Crew",
        resourceTitle: "full_name",
        resourceSchema: {},
        dataResource: "trip",
        resourceLink: {
          field: "employee_id",
          name: "employee"
        },

        resourceLinkClick: function(item) {
          this.$root.addResentTab(item);
        },

        link: "shipment_id",
        selectedTripId: null,
        deliveryStatus: null,
        itineraryStatus: null
      },
      totalVolume: 0,
      droppedObjectsHeaders: [],
      dataTableUnfiltered: []
    };
  },
  mounted() {
    var that = this;
    window.openTab = function(item) {
      that.$root.addResentTab(item);
    };
    this.$root.$on("tableSelectionChanged", t => {
      if (t.tableName == that.tableName) {
        if (t.selected[0] && (!that.selectedTrip || that.selectedTrip[0]._id != t.selected[0]._id)) {
          that.selectedTrip = t.selected;
          that.createTripMapData();
        }
      }
    });
    //rowAdded
    // this.$root.$on("record_updated", t => {
    //   if (t.tbl.tableName == that.tableName) {
    //     that.trips = t.tbl.table;
    //     var resource = fun.findRefDeep("resource", that);
    //     if (resource) {
    //       resource.toolBarkey = !resource.toolBarkey;
    //     }

    //     // that.refreshResources();
    //   }
    // });
    this.$root.$on("tableFilterChanged", t => {
      if (t.tableName == that.tableName) {
        console.log(t);
        that.resourceVBind.hideResource = t.currentFilter == 1;
        that.resourceVBind.hideData = t.currentFilter != 1;
        try {
          var split = that.$refs.calTblMap.$refs.resource.$refs.split;
          split.localhideA = that.resourceVBind.hideResource; //collapse resource
          split.localhideB = that.resourceVBind.hideData; //collapse data
        } catch (error) {
          //
        }
      }
    });
    this.createDataHeaders();

    this.$root.$on("tableMounted", t => {
      // console.log(t);
      if (t.k == "trip_jobs") {
        t.linkClick = this.linkClick;
      }
    });
    this.$root.$on("rowReordered", t => {
      if (t.$parent.tableName == "trip_jobs") {
        that.reordered = t.$parent.table;
        that.reordered.forEach((r, i) => {
          r.stop_number = i + 1;
        });
        t.$parent.loading = true;
        that.$refs.calTblMap.mapLoading = true;
        that.createTripMapData(that.reordered, function() {
          t.$parent.loading = false;
          that.$refs.calTblMap.mapLoading = false;
        });
      }
    });
    this.getData();
  },
  computed: {
    zoneList() {
      var zones = [];
      this.zones?.forEach(z => {
        zones.push(z.zone_name);
      });

      return zones;
    }
  },
  beforeDestroy() {},
  methods: {
    createDataHeaders() {
      var headers = [
        // "load_order",

        "shipment_id",
        "customer_name",
        "zone",
        "pickup_date",
        "pickup_status",
        "pickup_address",
        "delivery_address",
        "delivery_dates",
        "volume",
        "warehouse"
      ];
      var values = {
        // load_order: "itinerary.load_order",
        zone: "zone.zone_name",
        pickup_date: "service_date",
        warehouse: "itinerary.warehouse.warehouse_name",
        delivery_dates: "delivery_date_range"
      };
      this.droppedObjectsHeaders.push({ text: "", value: "drag", sortable: false, width: 30 });
      headers.forEach(key => {
        var value = values[key] || key;

        this.droppedObjectsHeaders.push({
          text: fun.capitalize(key),
          value: value,
          sortable: true
        });
      });
    },
    reloadResources() {
      this.getData();
    },
    activeTabChanged(tab) {
      console.log(tab);
      if (tab == 1 && !this.d) {
        //remove date filter
        this.$refs.calTblMap.getQry();
        this.showFullData = true;
        this.refreshResources();
        this.showFullData = false;
      }
    },
    updateTableRecord(a, shipmentId) {
      var that = this;
      var data = [];
      var currentShipment = that.resourceVBind.data.find(r => {
        return r._id == shipmentId;
      });
      // that.updatedItems = that.resourceVBind.data
      //   .filter(r => {
      //     return r.trip?._id == shipment.trip._id;
      //   })
      //   .sort((a, b) => a.itinerary.load_order - b.itinerary.load_order);
      // that.updatedItems
      //   .filter(s => {
      //     return s._id != shipment._id;
      //   })
      //   .forEach((r, i) => {
      //     r.itinerary.load_order = i + 1;
      //   });
      // var currentShipment = that.updatedItems.find(s => {
      //   return s._id == shipment._id;
      // });

      // currentShipment.trip = null;
      // currentShipment.itinerary.load_order = null;

      data.push({
        _id: shipmentId, // shipment id
        itinerary_id: currentShipment.itinerary._id,
        trip: null
      });
      // this.updateLoadOrder(true);
      axios
        .post(this.serverURL + "/update_trip", data, {
          withCredentials: true
        })
        .then(r => {
          that.refreshResources(true);
        })
        .catch(err => console.error(err));
    },
    doAssign(v, _id) {
      // console.log(v);
      // console.log(_id);
      // console.log(this.resourceVBind.data);
      var data = [];

      var rec = this.resourceVBind.data.filter(r => {
        return r._id == _id;
      })[0];
      if (v) {
        rec.trip = { _id: v._id, trip_name: v.trip_name };
      } else {
        rec.trip = null;
      }
      data.push(this.updateTableRecord({ item: rec }));

      // this.tableKey = !this.tableKey;

      axios
        .post(this.serverURL + "/add_bulk_data", data, {
          withCredentials: true
        })
        .then(r => {
          this.successMessage = r.data;
        });
    },
    dayClick(d, c) {
      console.log(d);
      this.d = d;
      this.refreshResources();
    },
    refreshResources(noTableReload, tripId) {
      // this.resourceVBind.hideResource = !tripId; //hide trip table when unassign from trip
      // this.resourceVBind.hideData = tripId; //hide unassigned table when assign to trip
      this.resourceVBind.hideResource = false;
      this.resourceVBind.hideData = false;
      try {
        this.$refs.calTblMap.$refs.resource.reload(noTableReload);
      } catch (error) {
        //
      }
    },
    dataTemplate: function(d, i) {
      if (!d.shipment_id) {
        return "";
      }

      if (i || i == 0) {
        if (d.itinerary) {
          // if (!d.itinerary.load_order && d.itinerary.load_order != 0) {
          if (d.itinerary.load_order == null) {
            d.itinerary.load_order = 0;
          } else {
            d.itinerary.load_order = i + 1;
          }
          d.itinerary.load_order = i + 1;
          this.resourceVBind.data.find(r => {
            return r.itinerary._id == d.itinerary._id;
          }).itinerary.load_order = d.itinerary.load_order;
        }
        // }
      }
      var borderColorPickupStatus = "";
      var borderColorDeliveryStatus = "";
      try {
        borderColorDeliveryStatus = this.deliveryStatus.find(s => {
          return s.status == d.delivery_status;
        }).color;
        borderColorDeliveryStatus = borderColorDeliveryStatus.replace("##", "#");
      } catch (error) {
        //
      }
      try {
        borderColorPickupStatus = this.itineraryStatus.find(s => {
          return s.status == d.pickup_status;
        }).color;
        borderColorPickupStatus = borderColorPickupStatus.replace("##", "#");
      } catch (error) {
        //
      }
      //  itinerary: <b>${d.itinerary?.step}</b><br/>
      //  Warehouse: <b>${d.itinerary?.warehouse?.warehouse_name}</b><br/>
      var template = `
       ${d.trip ? `<div class="circle-num">${d.itinerary.load_order || ""}</div>` : ""}
      <b> <a href="javascript:openTab({shipment_id: ${d.shipment_id},customer_name: '${d.customer_name}'})"> <b>#${
        d.shipment_id
      } ${d.customer_name}</a></b><br>
             From <b>${d.shipment_stop[0]?.full_address || "TBD"}</b> <br>
             To: <b>${d.shipment_stop && d.shipment_stop[1] ? d.shipment_stop[1].full_address : "TBD"} </b><br>

             Warehouse: <b>${d.itinerary.warehouse?.warehouse_name || "TBD"}</b><br/>
              Zone: <b>${d.zone?.zone_name}</b><br/>
              Delivery Type: <b>${d.itinerary?.step}</b><br/>
             Pickup Date: ${fun.formatDate(d.service_date)}<br>
              Delivery Dates: ${d.delivery_date_range || "TBD"}<br>

             Volume: ${d.volume} CF<br>
             Pickup Status: <span style="padding:5px; background-color: ${borderColorPickupStatus}; color:${fun.getReadableTextColor(
        borderColorPickupStatus
      )}" > ${fun.capitalize(d.itinerary.pickup_status)}</span><br/>

</span>
       <br/>




        `;
      //                Delivery Status: <span style="padding:5px; background-color: ${borderColorDeliveryStatus}; color:${fun.getReadableTextColor(
      //   borderColorDeliveryStatus
      // )}" > ${fun.capitalize(d.itinerary.delivery_status)}
      return template;
    },
    resourcesAsTable(d) {
      var resourceData = [];
      this.makeResourceTable(d, resourceData);
      return this.makeResourceMap(resourceData, d);
      // return this.generateResourceHTMLTable(resourceData);
    },
    makeResourceTable(dd, resourceData) {
      if (dd.resources) {
        this.resourceType.forEach(t => {
          var res = dd.resources.filter(r => {
            return r.resource_type == t.resource_type;
          });
          if (res.length) {
            if (res[0].qty) {
              var assignedQty = 0;
              if (dd.day_crew) {
                if (t.resource_type == "mover" && dd.day_crew.crew_employee) {
                  assignedQty = dd.day_crew.crew_employee.length;
                }
                if (t.resource_type != "mover" && dd.day_crew.resources) {
                  assignedQty = dd.day_crew.resources.filter(c => {
                    return c.resource_type == t.resource_type;
                  }).length;
                }
              }
              resourceData.push({
                resource: t.resource_type,
                qty: res[0].qty,
                assignedQty: assignedQty
              });
            }
          }
        });
      }
    },

    getData() {
      var that = this;
      var data_object = {
        object_name: "v_trip_itinerary",
        schema_name: "ld_dispatch",
        qry: {
          $and: [
            {
              $or: [
                { service_type: { $regex: "long[\\s_-]*distance", $options: "i" } },
                { service_type: { $regex: "interstate", $options: "i" } }
              ]
            },
            { itinerary: { $ne: null } }
          ]
        },
        additional_data: [
          {
            obj_name: "zone",

            fields: ["_id", "zone_name", "states", "counties", "cities", "movetype", "company", "type"]
          }
        ]
      };

      axios
        .post(this.serverURL + "/get_data", data_object, {
          withCredentials: true
        })
        .then(response => {
          this.resourceVBind.data = response.data.model;
          that.resourceVBind.data.forEach(r => {
            var dropOff = r.shipment_stop.find(s => {
              return s.value == "dropoff";
            });
            var pickUp = r.shipment_stop.find(s => {
              return s.value == "pickup";
            });
            if (dropOff) {
              // console.log(dropOff);
              var dropOffLocation = r.customer.address.find(a => {
                return a.full_address == dropOff.full_address;
              });
              if (dropOffLocation) {
                if (!dropOffLocation.location?.address?.geo) {
                  axios
                    .post(this.serverURL + "/parse_address", {
                      address: dropOff.full_address.full_address,
                      address_id: dropOff.address_id
                    })
                    .then(response => {
                      console.log(response.data);
                    });
                }
              }

              var address = dropOffLocation.location?.address?.geo?.location?.address;
              if (dropOffLocation.location?.zone) {
                r.zone = dropOffLocation.location.zone;
              }
              if (!dropOffLocation.location?.zone && address) {
                var zone = that.$root.findZone(dropOffLocation.location, that.zones);
                dropOffLocation.location.zone = zone?.zone;
                r.zone = zone?.zone;
                var data = {
                  metadata: {
                    object_name: "customer"
                  },
                  model: {
                    _id: r.customer._id,
                    address: r.customer.address
                  }
                };
                axios.post(this.serverURL + "/add_data", data, {
                  withCredentials: true
                });

                //
              }
              r.delivery_address = dropOffLocation.full_address;
              r.pickup_address = pickUp?.full_address;
            }
            // console.log(r);
          });

          that.$refs.calTblMap.resourceKey = !that.$refs.calTblMap.resourceKey;
        });
    },
    updateTable(t, f) {
      var that = this;

      var data = {
        metadata: {
          object_name: "trip"
        },
        model: t.item
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(r => {
          if (f) {
            f(r);
          }
        });
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },

    getItemColor(e, slot, item, tableName) {
      var color = "";
      switch (slot) {
        case "status":
          if (e) {
            try {
              color = this.statuses.filter(f => {
                return f.status == e;
              })[0].color;
            } catch (error) {
              console.log(error);
            }
          }
          break;

        case "trip_name":
          return "";

        default:
          break;
      }
      return color;
    },
    eventTemplate: function(e, data, obj) {
      var eventColor = e.color;
      if (e.customer && e.customer.address) {
        var address = "",
          ev,
          serviceDate;

        e.orig_city = e.origin.city;
        e.orig_state = e.origin.stateCode;
        address = e.orig_city + ", " + e.orig_state;

        e.dest_city = e.destination.city;
        e.dest_state = e.destination.stateCode;
        address = e.dest_city + ", " + e.dest_state;
        // }
      }

      serviceDate = new Date(e.etd);

      var endTime = serviceDate.addHours(1);
      if (e.etd) {
        serviceDate = new Date(e.etd);
      }
      var name = e.trip_name + " " + e.num_jobs + " Jobs";
      if (e.orig_warehouse) {
        name += " " + e.orig_warehouse.warehouse_name;
      }
      if (e.origin) {
        name += " " + e.origin;
      }
      if (e.agent) {
        name += " " + e.agent.company;
      }
      if (serviceDate) {
        const status = this.trip_status.find(s => {
          return s.status == e.status;
        });
        ev = {
          name: name,
          start: serviceDate,
          id: e._id,
          end: endTime,
          timed: true,
          color: status?.color,
          template: "my trip"
        };

        return ev;
      }

      return ev;
    },
    getTripRoute(trip, feedback) {
      var that = this;

      axios
        .post(
          this.serverURL + "/get_data",
          { object_name: "v_trip", qry: { _id: trip._id } },
          {
            withCredentials: true
          }
        )
        .then(response => {
          var data = response.data;
          var table = that.$refs.calTblMap.$refs.dTable;
          // this.$refs.calTblMap.tblVBind = data.schema["v-bind"];
          // that.$refs.calTblMap.$refs.dTable.editedItemTitle =
          //   data.schema["v-bind"].editedItemTitle;
          // data.schema["v-bind"].editedItemTitle.tblVBind.tableKey;
          // this.tableKey = !this.tableKey;
          this.tripJobs = data.model[0] ? data.model[0].trip_jobs : [];
          this.dataTable.forEach(d => {
            var dataModel = data.model.filter(m => {
              return m._id == d._id;
            })[0];
            if (dataModel) {
              d.trip_jobs = dataModel.trip_jobs;
            }
          });
          table.table = this.dataTable;
          if (this.tripJobs.length) {
            that.$refs.calTblMap.mapReady = true;
          } else {
            that.$refs.calTblMap.mapReady = false;
          }
          feedback(data.model[0] ? data.model[0].route : null);
        });
    },

    createTripMapData(reorder, feedback) {
      var that = this;
      that.mapData = [];

      if (!this.selectedTrip || !this.selectedTrip.length) {
        that.$refs.calTblMap.mapLoading = false;
        return;
      }
      var curTrip = this.selectedTrip[0];
      if (!reorder) {
        that.$refs.calTblMap.mapReady = true;
        that.$refs.calTblMap.mapLoading = true;
      }
      this.getTripRoute(curTrip, route => {
        that.$refs.calTblMap.mapLoading = false;
        if (route) {
          if (route[0].waypoints.length < that.tripJobs.length + 1) {
            route = null;
          } else {
            route[0].waypoints.forEach((w, i) => {
              if (i > 0) {
                var jobExist = that.tripJobs.filter(j => {
                  return (
                    j.destination.address.label == w.address ||
                    (j.next_stop && j.next_stop.warehouse && j.next_stop.warehouse._id == w.warehouse_id)
                  );
                });
                if (!jobExist.length) {
                  route = null;
                }
                // var tripJob = that.tripJobs[i - 1];
                // if (w.address != tripJob.destination.address.label) {

                // }
              }
            });
          }
        }
        curTrip.route = route;

        var whs;

        if (curTrip.orig_warehouse) {
          whs = this.warehouse.filter(w => {
            return w._id == curTrip.orig_warehouse._id;
          });
          if (whs.length) {
            if (whs[0].geo && whs[0].address) {
              this.mapData.push({
                pos: {
                  lat: whs[0].geo.position[0],
                  lng: whs[0].geo.position[1]
                },
                label: whs[0].warehouse_name,
                address: whs[0].address.address,
                shortLabel: '<div class="mdi mdi-forklift"></div>',
                markerColor: whs[0].color,
                warehouseId: whs[0]._id,
                extraClass: ["square"]
              });
            }
          }
        }
        // curTrip.route = null;
        if (reorder) {
          curTrip.route = null;
        }

        if (!curTrip.route) {
          if (!reorder) {
            this.tripJobs.forEach((j, i) => {
              var stops = j.stops;
              var label = j.first_name + " " + j.last_name + " #" + j.shipment_id;
              var addr;

              if (j.next_stop && j.next_stop.warehouse) {
                var curWhs = this.warehouse.filter(w => {
                  return w._id == j.next_stop.warehouse._id;
                });
                if (curWhs.length) {
                  var samePoint = this.mapData.filter(m => {
                    return m.pos.lat == curWhs[0].geo.position[0] && m.pos.lng == curWhs[0].geo.position[1];
                  });
                  if (!samePoint.length) {
                    this.mapData.push({
                      pos: {
                        lat: curWhs[0].geo.position[0],
                        lng: curWhs[0].geo.position[1]
                      },
                      label: label,
                      address: curWhs[0].address.address,
                      shortLabel: '<div class="mdi forklift"></div>',
                      warehouse_id: curWhs[0]._id,

                      _id: j._id,
                      service_id: j.service_id,
                      markerColor: this.getTripColor(curTrip) || ""
                    });
                  } else {
                    samePoint[0].label += "; \n" + label;
                  }
                }
              } else {
                if (j.destination) {
                  this.mapData.push({
                    pos: {
                      lat: j.destination.position[0],
                      lng: j.destination.position[1]
                    },
                    label: label,
                    address: j.destination.address.label,
                    shortLabel: '<div class="mdi mdi-home-circle"></div>',
                    color: "white",
                    warehouse_id: j.next_stop.warehouse ? j.next_stop.warehouse._id : "",

                    _id: j._id,
                    service_id: j.service_id,
                    markerColor: this.getTripColor(curTrip) || ""
                  });
                  // }
                }
              }
            });
          }
          if (whs.length) {
            var firstStop = whs[0];
            firstStop.pos = {
              lat: firstStop.geo.position[0],
              lng: firstStop.geo.position[1]
            };
          }

          if (!reorder) {
            this.mapData = this.getSequence(this.mapData, whs[0]);
          } else {
            reorder.unshift(this.mapData[0]);
          }

          this.calculateTripRoute(reorder, function() {
            that.prepareTripLegend(curTrip);
            if (feedback) {
              feedback();
            }
          });
        } else {
          this.mapData = curTrip.route;
          that.prepareTripLegend(curTrip);
        }
      });
    },
    getSequence(data, firstStop, filter) {
      // var mileage = 10000;
      var filtered = data;
      if (filter) {
        filtered = data.filter(r => {
          return eval(filter);
        });
      }
      filtered.forEach(d => {
        if (d.pos) {
          d.mileage = fun.mileage(firstStop.pos.lat, firstStop.pos.lng, d.pos.lat, d.pos.lng);
        }
      });
      fun.sortObjects(filtered, "mileage");
      return filtered;
    },
    prepareTripLegend(curTrip) {
      this.getTripsMapData(
        this.prepareTripWaypoints(
          curTrip,
          fun.clone(this.mapData[0].waypoints),
          this.tripJobs,
          this.mapData[0].mapLine.service.route.leg
        ),
        {
          stop_number: {
            title: " "
          },

          delivery_date_range: {
            title: "Del. Range"
          },
          eta: {},
          label: {
            title: "Customer"
          },
          driving_time: {
            title: "Drv. Time"
          },
          mileage: {}
        }
      );

      this.$root.$emit("mapDataChanged", {
        data: this.mapData,
        legend: this.mapLegend,
        updateLegend: true
      });
      this.$refs.calTblMap.mapLoading = false;
    },
    calculateETA(start, drivingTime) {
      // console.log(start, drivingTime);
      var end = start.addHours(parseFloat(drivingTime));
      end = end.addHours(1);
      return end;
    },
    prepareTripWaypoints(trip, mapData, tripJobs, leg) {
      var start = new Date(trip.etd);
      if (!start.getHours()) {
        start = start.addHours(8);
      }
      var startTime = start;

      mapData.forEach((d, i) => {
        d.stop_number = i;
        if (i > 0 && leg[i - 1]) {
          var drivingTime = (leg[i - 1].travelTime / 3600).toFixed(2);
          var eta = this.calculateETA(startTime, drivingTime);
          if (tripJobs.length && tripJobs[i - 1]) {
            d.delivery_date_range = tripJobs[i - 1].delivery_date_range;
          }

          d.mileage = (leg[i - 1].length / 1.6 / 1000).toFixed(2);
          d.driving_time = drivingTime;
          d.eta = fun.formatDate(eta, false, true);
          startTime = eta;
        }
      });

      mapData.splice(0, 1);
      return mapData;
    },
    getTripsMapData(editData, properties) {
      this.mapLegend = {
        getFreshData: false,
        mobileBreakpoint: 0,
        get_table: "all",
        all_records: true,
        table_title: "Trips Jobs",
        tableName: "trip_jobs",
        hasSearch: false,
        isDraggable: true,
        // headers: ["shipment_id"],
        editData: editData,
        data_object: {
          schema: {
            properties: properties
          }
        },

        hideHeader: false,
        singleSelect: false,
        width: 4,
        disablePagination: true
      };
    },
    calculateRoute(model, fn) {
      axios
        .post(this.serverURL + "/get_route", model, {
          withCredentials: true
        })
        .then(response => {
          fn(response.data);
        })
        .catch(reason => {
          console.log(reason);
        });
    },
    calculateTripRoute(reorder, feedback) {
      var that = this;
      if (!that.selectedTrip.length || !that.tripJobs.length) {
        return;
      }
      var data = {
        waypoints: []
      };
      var mapData = that.mapData;

      if (reorder) {
        mapData = reorder;
      }
      mapData.forEach((w, i) => {
        if (w.pos) {
          data.waypoints.push(w.pos.lat + "," + w.pos.lng);
          if (i > 0) {
            if (w.shortLabel.toString().includes("forklift")) {
              w.extraClass = ["square"];
            }

            w.shortLabel = i;
            w.markerColor = that.mapData[0].markerColor;
            w.color = "white"; //
          }
        }
      });

      that.calculateRoute(data, r => {
        // t.tbl.customBtnLoading = false;

        that.mapData = [
          {
            mapLine: {
              service: {
                route: r[0]
              }
              // color: mapData[0].markerColor,
            },
            waypoints: mapData
          }
        ];
        var data = {
          metadata: {
            object_name: "trip"
          },
          model: {
            _id: that.selectedTrip[0]._id,
            route: that.mapData
          }
        };

        axios
          .post(this.serverURL + "/add_data", data, {
            withCredentials: true
          })

          .then(response => {
            if (reorder) {
              // that.createDataObject();
            }
          });

        feedback();
      });
    },
    getTripColor(r) {
      try {
        return this.trips.filter(t => {
          return r._id == t._id;
        })[0].color;
      } catch (error) {
        return "";
      }
    },

    getDataObject(tbl) {
      var data_object = {
        object_name: "v_trip_no_route",
        // object_name: "v_trip",
        // schema_name: "v_trip",
        object_name_to_update: "trip",

        // qry: { "agent._id": this.curAgent._id },
        date_fields: ["date"],
        mobileBreakpoint: 0,
        id_fields: ["agent_id"],

        alwaysAddId: true,
        all_records: true,
        get_table: "all",
        additional_data: [
          { obj_name: "warehouse" },
          { obj_name: "trip_status" },
          { obj_name: "delivery_status" },
          { obj_name: "itinerary_status" },
          {
            obj_name: "zone",

            fields: ["_id", "zone_name", "states", "counties", "cities", "movetype", "company", "type"]
          }
          //itinerary_status
          // {
          //   obj_name: "v_sit_schedule",
          //   fields: ["first_name", "last_name", "shipment_id", "trip_id"],
          //   qry: {
          //     trip: { $ne: null },
          //   },
          // },
        ],
        additional_structure: [
          // { obj_name: "employee", schema_name: "resource_crew" },
          { obj_name: "v_trip_no_route" }
        ],

        table_title: "Trips",
        hasSearch: true
      };
      return data_object;
    },

    onMarkerClick(data, e) {
      var topElement = e.target.closest(".map-outer").getElementsByClassName("map-top")[0];
      var innerElement = e.target.closest(".map-outer").getElementsByClassName("map-inner")[0];

      var unassign = false;
      var msg = "";

      if (data.legend.selected[0] && topElement.innerHTML == data.legend.selected[0].employee_id) {
        unassign = true;
      }
      msg = "Confirm assigning " + data.legend.selected[0].full_name + " to #" + data.shipment_id + "?";

      if (unassign) {
        msg = "Confirm unassigning #" + data.shipment_id + "?";
      }

      data.foreman = {
        _id: data.legend.selected[0]._id,
        full_name: data.legend.selected[0].full_name
      };
      this.dataTable.filter(r => {
        return r._id == data._id;
      })[0].foreman = data.foreman;
      this.updateTable({ item: data }, resp => {
        if (data.foreman) {
          this.updateForemanOnMap(data, topElement);
        }
      });
    },
    createDataTrip(data) {
      console.log(data.table);
      this.filterTabs = [];
      if (data.additional_model) {
        this.statuses = data.additional_model.trip_status;
        this.tripCustomers = data.additional_model.v_sit_schedule;
        this.statuses.forEach(s => {
          this.filterTabs.push({
            caption: fun.capitalize(s.status),
            name: "status",
            value: s.status,
            color: s.color
          });
        });
      }

      this.filterCondition = "";

      this.dataTable.forEach(r => {
        if (this.tripCustomers) {
          var tripCustomers = this.tripCustomers.filter(c => {
            return c.trip_id == r._id;
          });

          var tripJobs = "";
          tripCustomers.forEach(a => {
            tripJobs += " " + a.first_name + " " + a.last_name + "#" + a.shipment_id + "<br>";
            // var lines = tripJobs.split(/\r\n|\r|\n/g);
            // console.log(lines)
          });
          r.num_jobs = tripCustomers.length;
        }
        r.trip_jobs = tripJobs;

        switch (r.trip_type) {
          case "d2w":
            break;
          case "w2w":
          case "w2d":
            if (r.orig_warehouse) {
              r.origin = "warehouse: " + r.orig_warehouse.warehouse_name;
            }
            if (r.dest_warehouse) {
              r.destination = "warehouse: " + r.dest_warehouse.warehouse_name;
            }

            break;

          case "d2d":
            break;
          default:
            break;
        }
      });
    },
    updateForemanOnMap(data, topElement) {
      var curForeman = this.foreman.filter(f => {
        return f._id == data.foreman._id;
      });
      if (curForeman[0]) {
        topElement.innerHTML = curForeman[0].employee_id;
        topElement.style.backgroundColor = curForeman[0].color;
        topElement.style.display = "block";
      }
    },
    eventClick(e, cal) {
      console.log(e);
      this.selectedTripId = e.event.id;
      // cal.resourceKey = !cal.resourceKey;

      // this.dataTable = fun.clone(this.fullData);
      // this.dataTable = this.dataTable.filter((d) => {
      //   return d._id == e.event.id;
      // });
      // this.singleSelect = true;
      // this.selectedTrip = this.dataTable;
      // this.$refs.calTblMap.tableData = this.dataTable;
      // this.$refs.calTblMap.tableReady = true;
      this.$refs.calTblMap.activeTab = 1;
      // this.createTripMapData();
      // this.$refs.calTblMap.dayClick();
    },
    getLocation(r, stopType) {
      var stops = r.stops;
      var st = stops.filter(s => {
        return s.value == stopType;
      })[0];
      if (st) {
        var location = r.customer.address.filter(a => {
          return a.full_address == st.full_address;
        })[0];
        if (location && location.location.address.geo) {
          location = location.location.address.geo;
        }
        return location;
      }
    },
    updateLoadOrder(refresh) {
      var data = [];
      var that = this;
      this.updatedItems.forEach(shipment => {
        data.push({
          _id: shipment._id, // shipment id
          itinerary_id: shipment.itinerary._id,
          load_order: shipment.itinerary.load_order
        });
      });
      axios
        .post(this.serverURL + "/update_load_orders", data, {
          withCredentials: true
        })
        .then(r => {
          if (refresh) {
            that.refreshResources(true);
          }
        })
        .catch(err => console.error(err));
    },
    assignToTrip(trip) {
      var data = [];
      var that = this;
      // var trip = this.trips.find(t => {
      //   return t._id == tripId;
      // });
      this.selectedTripJobs.forEach(shipment => {
        data.push({
          _id: shipment._id, // shipment id
          itinerary_id: shipment.itinerary._id,
          load_order: shipment.itinerary.load_order,
          trip: trip // full trip object
        });
      });

      axios
        .post(this.serverURL + "/update_trip", data, {
          withCredentials: true
        })
        .then(r => {
          that.selectedTripJobs = [];
          that.refreshResources();
        })
        .catch(err => console.error(err));
    },
    onDataReceived(data, d) {
      var that = this;

      var f = fun;
      this.mapData = [];
      if (d) {
        this.d = d;
      } else {
        d = this.d;
      }
      try {
        this.warehouse = data.additional_model.warehouse;
      } catch (error) {
        //
      }
      try {
        this.trip_status = data.additional_model.trip_status;
      } catch (error) {
        //
      }
      try {
        this.deliveryStatus = data.additional_model.delivery_status;
      } catch (error) {
        //
      }
      try {
        this.itineraryStatus = data.additional_model.itinerary_status;
      } catch (error) {
        //
      }
      try {
        this.tripCustomers = data.additional_model.v_sit_schedule;
      } catch (error) {
        //
      }
      if (!this.zones.length) {
        this.zones = data.additional_model?.zone;
      }
      if (!this.trips?.length) {
        this.trips = data.model;
      }

      this.dataTable = data.model;

      this.resourceVBind.resources = [];
      this.resourceVBind.reloadResources = this.getData;
      this.resourceVBind.groupBy = "itinerary.warehouse.warehouse_name";
      // this.resourceVBind.groupBy = "zone.zone_name";
      this.resourceVBind.noGroupLabel = "Not In Warehouse";
      // this.resourceVBind.noGroupLabel = "No Zone";
      if (data.additional_structure) {
        this.resourceVBind.resourceSchema = data.additional_structure.v_trip_no_route;
      }
      this.resourceVBind.searchLabel = "Search By Customer or Shipment ID";
      this.resourceVBind.customSearchControls = [
        {
          display: "v-combo",

          key: "zone.zone_name",
          class: "mt-4",
          vBind: {
            label: "To Zone",
            multiple: true,
            items: this.zoneList
          }
        },
        {
          display: "v-date-range-picker",
          class: "mt-4",
          objectType: "dateRange",
          key: "delivery_date_range",
          vBind: {
            label: "Delivery Date Range"
          }
        },
        {
          display: "v-range-slider",
          key: "volume",
          class: "mt-6",
          objectType: "range",
          style: "width:350px; padding-top:16px",
          vBind: {
            label: "Volume Range",
            min: 0,
            max: 2000,
            step: 100,
            ticks: "always",
            "thumb-label": "always",
            "tick-size": 4
          },
          slot: {
            slotName: "thumb-label",
            slotDef: {
              is: "span",

              content(props) {
                return props.value;
              }
            }
          }
        }
      ];
      //searchTabs
      this.resourceVBind.searchTabs = [];
      this.resourceVBind.droppedTableId = "service_id";
      // this.trip_status.forEach(s => {
      //   this.resourceVBind.searchTabs.push({
      //     tabName: s.status,
      //     color: s.color
      //   });
      // });
      // this.resourceVBind.onSearchTabsChange = function(t, tbl) {
      //   // console.log(that.resourceVBind.searchTabs[t]);
      //   that.dataTable = that.dataTableUnfiltered.filter(d => {
      //     return d.status == that.resourceVBind.searchTabs[t].tabName;
      //   });
      // };
      this.resourceVBind.selectTemplate = function(selectedRows) {
        let totalVolume = 0;
        selectedRows.forEach(r => {
          if (!isNaN(r.volume)) {
            totalVolume += parseFloat(r.volume);
          }
        });
        that.totalVolume = totalVolume;
        return `Total Selected ${totalVolume} cf`;
      };
      this.resourceVBind.splitPercent = 30;
      this.resourceVBind.hideResource = true; //hide trip panel initialy
      this.resourceVBind.showResourceLabel = "View Available Trips";
      this.resourceVBind.allRecords = true;
      this.resourceVBind.update = this.updateTableRecord;

      var resourceTable = this.resourceVBind.resourceSchema["v-bind"];
      resourceTable.droppedTableId = "service_id";
      resourceTable.tableName = this.tableName;
      resourceTable.draggedObjectsSortField = "load_order";
      resourceTable.draggedObjectsName = "trip_jobs";
      resourceTable.hoverRowFn = function(item) {
        // return class (or null)
        if (that.selectedTripJobs?.length) {
          return "hover-row";
        }
        return null;
      };
      resourceTable.hoverTooltipFn = function(item) {
        // return tooltip text (or null)
        if (that.selectedTripJobs?.length && item?.trip_name) {
          that.selectedTripJobs.forEach(t => {
            const tripId = t.trip?._id;
            let trip = that.trips.find(r => {
              return r._id == tripId;
            }); // in case if the trip name was updated after trip assigned
            if (trip && t.trip) {
              t.trip.trip_name = trip.trip_name;
            }
          });
          if (
            that.selectedTripJobs.some(t => {
              return t.trip?.trip_name == item?.trip_name; //same trip
            })
          ) {
            return null;
          }

          const availability = item.capacity - item.loaded_volume;
          let overload = "";
          if (that.totalVolume > availability) {
            overload = "(Will be overloaded)";
          }

          const text = `Assign ${that.selectedTripJobs.length} jobs (${that.totalVolume} CF) to ${item.trip_name} (${availability} CF available) ${overload}`;
          return {
            text,
            color: overload ? "red" : "green"
          };
        }

        return null;
      };

      resourceTable.rowClick = function(r) {
        // console.log(r);
        if (that.selectedTripJobs.length) {
          that.assignToTrip(r);
        }
      };
      resourceTable.droppedObjectsSortProperty = "itinerary.load_order";
      resourceTable.droppedObjectsAsTable = true;
      resourceTable.droppedObjectsHeaders = this.droppedObjectsHeaders;
      resourceTable.droppedObjectsTitle = "Jobs On Trip";
      resourceTable.droppedObjectsCustomControls = [
        // {
        //   display: "v-combo",

        //   key: "trip",
        //   ref: "trip_list",
        //   class: "mt-6",
        //   onlyWithSelection: true,

        //   vBind: {
        //     label: "Move Selected to Trip",
        //     itemText: "trip_name",
        //     itemValue: "_id",
        //     filter: true,
        //     textTemplate:
        //       "`${i.trip_name} available: ${(parseFloat(i.capacity || 0) - parseFloat(i.loaded_volume || 0)) }  cf`",
        //     onChange: i => {
        //       that.assignToTrip(i);
        //     },

        //     items: this.trips
        //   }
        // },
        {
          display: "v-btn",

          key: "unassign_btn",
          ref: "unassign_btn",
          class: "ma-2",
          onlyWithSelection: true,

          vBind: {
            innerText: "Unassign Selected",

            click: () => {
              that.assignToTrip();
            }
          }
        }
      ];
      resourceTable.droppedObjectsShowConrols = function(c) {
        // console.log(c);
        if (c.onlyWithSelection) {
          return that.selectedTripJobs.filter(s => {
            return s.trip;
          }).length;
        }

        return true;
      };
      resourceTable.droppedObjectsLink = function(item) {
        that.$root.addResentTab({ shipment_id: item.shipment_id, customer_name: item.customer_name });
      };
      resourceTable.droppedObjectSelect = function(selectedItems) {
        that.selectedTripJobs = selectedItems;
        let totalVolume = 0;
        selectedItems.forEach(r => {
          if (!isNaN(r.volume)) {
            totalVolume += parseFloat(r.volume);
          }
        });
        that.totalVolume = totalVolume;
        // return `Total Selected ${totalVolume} cf`;
        that.resourceVBind.selectedRecordsInResources = selectedItems;
        // that.refreshResources(true);
      };
      resourceTable.sortedDraggedObjectsOnRowReorder = function(item, list) {
        that.updatedItems = list;
        that.updateLoadOrder();
      };

      resourceTable.dropItemHandling = function(trip, shipment, index, tbl) {
        let data = [];
        that.updatedItems = that.resourceVBind.data
          .filter(r => {
            return r.trip?._id == trip._id;
          })
          .sort((a, b) => a.itinerary.load_order - b.itinerary.load_order);
        let updatedItem = shipment;
        if (
          !tbl.droppedObjects.some(d => {
            //new item dropped
            return d._id == updatedItem._id;
          })
        ) {
          updatedItem.trip = {
            _id: trip._id,
            trip_name: trip.trip_name
          };
          tbl.droppedObjects.push(updatedItem);
          updatedItem.itinerary.load_order = that.updatedItems.length + 1;
          // update item in data
          that.resourceVBind.data.find(d => {
            return d._id == shipment._id;
          }).trip = updatedItem.trip;

          // 3. Push to backend update list
          data.push({
            _id: shipment._id, // shipment id
            itinerary_id: shipment.itinerary._id,
            load_order: shipment.itinerary.load_order,
            trip: updatedItem.trip // full trip object
          });

          // 5. Force refresh
          tbl.dropKey = !tbl.dropKey;

          // 6. Send update to backend
          axios
            .post(this.serverURL + "/update_trip", data, {
              withCredentials: true
            })
            .then(r => {
              that.refreshResources(true);
            })
            .catch(err => console.error(err));
        } else {
          //reordering items

          let currentLoadOrder = updatedItem.itinerary.load_order;
          let newLoadOrder = index + 1;
          let dir = "";

          if (newLoadOrder < currentLoadOrder) {
            // moved left
            dir = "left";
          } else {
            dir = "rignt";
          }

          that.updatedItems.forEach((obj, idx) => {
            if (obj._id != updatedItem._id)
              if (dir == "left") {
                if (obj.itinerary.load_order >= newLoadOrder) {
                  if (obj.itinerary.load_order < currentLoadOrder) {
                    obj.itinerary.load_order += 1; // Assign a new load_order starting from 1
                  }
                }
              } else {
                if (obj.itinerary.load_order <= newLoadOrder && obj.itinerary.load_order > 1) {
                  obj.itinerary.load_order -= 1; // Assign a new load_order starting from 1
                }
              }
            else {
              obj.itinerary.load_order = newLoadOrder;
            }
          });

          that.updatedItems.sort((a, b) => a.itinerary.load_order - b.itinerary.load_order);
          that.updateLoadOrder();
        }
      };
      this.resourceVBind.resourceFilter = function(data) {
        if (!data?.table) {
          data.table = [];
        }
        // data.table.forEach(t => {
        //   var type = t.trip_type.split("2");

        //   t.icon = fun.getItineraryIcon(type[0]);
        //   t.icon2 = fun.getItineraryIcon(type[1]);
        //   // "<span class='large-icon>'<i class='mdi mdi-warehouse'></i></span>";
        // });
        data.model = data.table;
        if (that.d || that.showFullData) {
          data.table = data.table.filter(m => {
            return f.formatDate(m.etd) == f.formatDate(that.d) || that.showFullData || !that.d;
          });
          data.model = data.table;
          that.d = null;
          return data;
        }
        if (that.selectedTripId) {
          data.table = data.table.filter(m => {
            return m._id == that.selectedTripId;
          });
          // data.model = data.table;
          that.selectedTripId = null;
          return data;
        }
        return data;
      };
      data.events = [];
      data?.model?.forEach(r => {
        var ev = this.eventTemplate(r);
        data.events.push(ev);
      });
      return data;
      // if (d) {
      //   var serviceDate = fun.getFullDate(d);
      //   this.dataTable = data.model.filter(m => {
      //     return fun.getFullDate(new Date(m.date)) == serviceDate;
      //   });

      //   return this.dataTable;
      // } else {
      //   this.fullData = data.model;
      //   return data.model;
      // }

      // return data.model;
    },
    replaceColor(obj) {
      var classes = "";
      if (obj) {
        obj.forEach(s => {
          try {
            if (s.color && s.color.replace) {
              if (s.color.length == 9 && s.color[0] == "#") {
                s.color = s.color.substr(0, 7);
              }
              var className = "color-" + s.color.replace("#", "");
              var classCss = "background-color:" + s.color + "; color:" + "white";
              // fun.invertColor(s.color);
              var cl = "\n." + className + " { " + classCss + "}";
              if (classes.indexOf(cl) == -1) {
                classes += cl;
              }
            }
          } catch (error) {
            console.log(error);
          }
        });
        this.$root.dynamicClasses(classes);
      }
    }
  }
};
</script>

<style lang="css" scoped></style>
